<template>
  <!-- <v-row justify="center"> -->
  <v-container class="contenedor_principal">
    <v-container class="continer_recuperar">
      <form :style="{ 'margin-top': `${alturatotal}%` }">
        <p
          class="txt_indicaciones"
        >Ingrese la nueva contraseña</p>
         <v-text-field
          label="CONTRASEÑA"
          prepend-inner-icon="mdi-lock-outline"
          v-model="password"
          :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
          :error-messages="passwordErrors"
          @input="$v.password.$touch()"
          @blur="$v.password.$touch()"
          :type="show1 ? 'text' : 'password'"
          @click:append="show1 = !show1"
        ></v-text-field>

        <v-text-field
          label="CONFIRMAR CONTRASEÑA"
          prepend-inner-icon="mdi-lock-outline"
          v-model="repeatPassword"
          :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
          :error-messages="repeatpasswordErrors"
          @input="$v.repeatPassword.$touch()"
          @blur="$v.repeatPassword.$touch()"
          :type="show2 ? 'text' : 'password'"
          @click:append="show2 = !show2"
        ></v-text-field>
      </form>
    </v-container>
    <div class="orange text-center py-3 my-2" v-if="mostrar_error">
      <span class="white--text body-1">{{ mensaje_error }}</span>
    </div> 
    <v-footer absolute class="font-weight-medium" padless>
      <v-btn x-large color="#58C4B5" dark style="width: 100%;" @click="submit('home')">GUARDAR</v-btn>
    </v-footer>
  </v-container>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength, sameAs } from "vuelidate/lib/validators";
import Vista from "@/objetos/vista";
import Conexion_api from "@/api/Conexion_api.js";
import Usuario from "@/objetos/usuario";

export default {
  mixins: [validationMixin],

  validations: {
    password: { required, minLength: minLength(8) },
    repeatPassword: {
      sameAsPassword: sameAs('password')
    }
  },

  components: {},
  data: () => ({
    alert: true,
    show1: false,
    show2: false,
    password:"",
    repeatPassword:"",
    usuario: Usuario,
    mostrar_error:false,
    mensaje_error:null,    
  }),
  mounted() {
    Vista.nombre = "/verificar";
  },
  computed: {
    passwordErrors(){
        const errors = [];
        if (!this.$v.password.$dirty) return errors;
        !this.$v.password.minLength &&
            errors.push("CONTRASEÑA de tener mínimo 8 caractares.");
        !this.$v.password.required && errors.push("CONTRASEÑA es obligatorio.");
        return errors;
    },
    repeatpasswordErrors(){
        const errors = [];
        if (!this.$v.repeatPassword.$dirty) return errors;  
        !this.$v.repeatPassword.sameAsPassword &&
            errors.push("La contraseña debe ser igual.");
        return errors;
    },
    alturatotal () {
      let dimension;
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': 
          dimension = '-30'
        break;
        case 'sm': 
          dimension ='-20'
        break
        case 'md': 
          dimension = '-10'
        break
        case 'lg': 
          dimension = '-10'
        break;
        case 'xl':
          dimension = '-3'
        break;
      }
      return dimension
    }     
  },
  methods: {
    submit() {
      this.$v.$touch();
      
       if (this.$v.$invalid) return;
        this.mostrar_error = false
        Conexion_api({
          body: {
            ...Usuario,
            password   : String(this.password),
            confirmar_password  : String(this.repeatPassword),
          },
          evento: "login/nueva_clave_pedidos"
        }).then(respuesta => {
            if (respuesta.data.error) {
              this.$root.$emit('snackbar',{ 
                color:"error",
                texto:  respuesta.data.error})   
                return 
            }          
            Usuario.nombre = respuesta.data.datos.usuario.nombre
            Usuario.nombre_vista = respuesta.data.datos.usuario.nombre
            Usuario.direccion = respuesta.data.datos.usuario.direccion
            Usuario.rut = respuesta.data.datos.usuario.rut            
            Usuario.coordenadas = respuesta.data.datos.usuario.coordenadas
            this.$cookie.set('pwst', respuesta.data.datos.token, { expires: '1h' });         
            this.$router.push("/distribuidor")

        }).catch(err => {
            err = String(err)
            console.error(err)
        })   
    },
    clear() {
      this.$v.$reset();
    }
  }
};
</script>

<style scoped>
.contenedor_principal {
  display: table;
  height: 100%;
}
.continer_recuperar {
  border-radius: 10px;
  margin-top: 12%;
  width: 100%;
  display: table-cell;
  vertical-align: middle;
}
.txt_indicaciones {
    text-align: center; color:#515C6F; font-size:15px; 
}
</style>